import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { DataService } from '@Core/services/proprietary/data.service';
import { Datasource, DataSourceStatus } from '@Core/services/proprietary/datasource';
import { cloneDeep } from 'src/ep-utils';
import { ContractState } from './contract.state';
import { UpdatePartyAgreement } from './party.actions';
import { PartyState } from './party.state';

@Injectable()
export class PartyAgreementService {
    private dsAgmt: Datasource;
    private dsAgmtSub: Subscription;

    constructor(private store: Store, private ds: DataService) { }

    initializeService() {
        this.dsAgmt = this.ds.addNewDatasource('BrokerAgreementTerm');
    }

    endservice() {
        if (this.dsAgmtSub) {
            this.dsAgmtSub.unsubscribe();
        }
        if (this.dsAgmt) {
            this.ds.deleteDatasource(this.dsAgmt);
        }
    }

    autoAddBrokerAgreement(brokerParty: any) {
        let criteria: any = {};
        criteria.Entity_Name = brokerParty.Broker.Entity_Name;
        criteria.Entity_Name_Mode = 'CONTAINSALLWORDS';
        criteria.Range = 'Eff';
        criteria.View = 'Standard';
        let contract = this.store.selectSnapshot(ContractState.contract);
        contract = cloneDeep(contract);

        if (contract.Eff_Date && contract.Eff_Date != '') {
            criteria.As_Of_Date = contract.Eff_Date;
        }
        if (contract.Contract_State && contract.Contract_State != '') {
            criteria.State = contract.Contract_State;
        }
        if (contract.Line_Code && contract.Line_Code != '') {
            criteria.Line_Code = contract.Line_Code;
        }
        if (contract.Program && contract.Program != '') {
            criteria.Program = contract.Program;
        }

        this.dsAgmtSub = this.dsAgmt.status$.subscribe((status) => {
            this.autoAddBrokerAgreementSub(status);
        });

        this.dsAgmt.getCollection(criteria, true, true);
    }

    autoAddBrokerAgreementSub(status: DataSourceStatus) {
        switch (status) {
            case DataSourceStatus.Ready:
                if (this.dsAgmtSub) {
                    this.dsAgmtSub.unsubscribe();
                }
                if (this.dsAgmt && this.dsAgmt.objectNodes.length == 1) {
                    let brokerID = this.dsAgmt.objectNodes[0].BrokerAgreement.Broker.Entity_ID;
                    let brokerParty;
                    let brokerFound = false;

                    const brokers = this.store.selectSnapshot(PartyState.brokerParties);

                    for (var i in brokers) {
                        if (
                            brokers[i].nodeType == 'Contract_Broker' &&
                            brokers[i].Principal_Ind == 'Y' &&
                            brokers[i].Broker.Entity_ID == brokerID
                        ) {
                            brokerFound = true;
                            brokerParty = cloneDeep(brokers[i]);
                            if (!brokerParty.Agreement) {
                                brokerParty.Agreement = {};
                            }
                            break;
                        }
                    }

                    if (brokerFound) {
                        this.store.dispatch(new UpdatePartyAgreement(brokerParty, this.dsAgmt.objectNodes[0]));
                    }
                    this.endservice();
                }
                break;
            case DataSourceStatus.Error:
                if (this.dsAgmtSub) {
                    this.dsAgmtSub.unsubscribe();
                }
                this.endservice();
                break;
        }
    }
}
